import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

declare var $: any;

@Component({
    selector: 'loyaltic-feedback-success',
    templateUrl: './feedback-success.component.html',
    styleUrls: ['./feedback-success.component.scss'],
    standalone: false
})
export class FeedbackSuccessComponent implements OnInit {

  @ViewChild('feedbackSuccess', { static: false }) feedbackSuccessRef: any;

  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  constructor(private modalService: BsModalService) {
  }

  ngOnInit() {
  }



  ngAfterViewInit() {
    this.modalRef = this.modalService.show(this.feedbackSuccessRef, this.popupConfig);

  }

}
